export enum ReceivedRejectEnum {
  RECEIVED_REJECTED_ITEM = 1,
  RECEIVED_REJECTED_MONEY = 2,
  RECEIVED_REJECTED_ADJUSTMENT = 3
}